module.exports = __webpack_public_path__ + "img/classroom.e3295faa.png";